export const fallbackPageKey = "home";
const validPageKeys = new Set(["home", "expenses", "analysis", "budget", "settings", "help", "dev", "db-error"]);

export function isValidPageKey(pageKey) {
  return validPageKeys.has(pageKey);
}
